<div class="org-info-section">
  <div>
    <div class="title">Organization Info</div>
    <form [formGroup]="orgForm">
      <div class="input-container">
        <div>
          <label for="orgName" [class.red]="editMode && f.orgName.dirty && f.orgName.errors"> Organization Name </label>
          @if (editMode && f.orgName.dirty && f.orgName.errors?.required) {
            <span class="red"> is required</span>
          }
        </div>
        <div class="flex items-center gap-[8px]">
          @if (!editMode) {
            <div
              class="max-w-[430px] h-[52px] leading-[52px] mx-[23px] text-[16px] text-[#5a5a5a] border border-solid border-transparent rounded-[26px]"
              gnxTextOverflowEllipsis
              #orgName="gnxTextOverflowEllipsis"
              [matTooltip]="orgName.tooltipText"
              [matTooltipDisabled]="!orgName.isOverflowed"
              matTooltipClass="blue-md-tooltip"
            >
              {{ data().organization.name }}
            </div>
            <div
              matTooltip="Permission required for this action"
              [matTooltipDisabled]="isAdmin()"
              matTooltipClass="blue-md-tooltip wide"
            >
              <button type="button" class="edit-btn" [disabled]="!isAdmin()" (click)="isAdmin() && onEdit()">
                Edit
              </button>
            </div>
          } @else {
            <input
              id="orgName"
              formControlName="orgName"
              placeholder="Name"
              (keydown.enter)="onSaveWithConfirmation()"
              class="w-[430px] h-[52px] px-[23px] text-[16px] flex items-center border border-solid rounded-[26px] bg-white outline-none placeholder:text-[#999999]"
              [class]="{
                'border-red-500': f.orgName.dirty && f.orgName.errors,
                'border-[#d5d7db]': !(f.orgName.dirty && f.orgName.errors),
              }"
            />
            <button type="button" class="cancel-btn" (click)="onCancelEdit()">Cancel</button>
            <button
              type="button"
              class="save-btn"
              [disabled]="!orgForm.dirty || orgForm.invalid || auth0Store.updateOrgInProgress()"
              (click)="onSaveWithConfirmation()"
            >
              @if (auth0Store.updateOrgInProgress()) {
                <gnx-dots-loader />
              } @else {
                Save
              }
            </button>
          }
        </div>
        @if (editMode && f.orgName.dirty && f.orgName.errors?.uniqueOrgViolation) {
          <span class="red note-msg">{{ uniqueOrgViolationMsg }}</span>
        }
      </div>
    </form>
  </div>
</div>
